import React from "react";
import { Button, Card } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import { JobType } from "../types";

interface JobStatusCardProps {
  title: string;
  description: string;
  schedule: string;
  jobType: JobType;
  onTrigger: (jobType: JobType) => void;
  isLoading: boolean;
}

export const JobStatusCard: React.FC<JobStatusCardProps> = ({
  title,
  description,
  schedule,
  jobType,
  onTrigger,
  isLoading,
}) => {
  return (
    <Card size="small" title={title}>
      <div className="space-y-2">
        <p className="text-sm text-gray-600">{description}</p>
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <ClockCircleOutlined />
            <span className="text-sm">{schedule}</span>
          </div>
          <Button
            size="small"
            type="primary"
            onClick={() => onTrigger(jobType)}
            loading={isLoading}
          >
            Trigger Now
          </Button>
        </div>
      </div>
    </Card>
  );
}; 